import React from 'react';
import { MAP_VIEW_3D, MAP_VIEW_CLASSIC, useMapView } from '../../map-view/MapViewContext';

export default function MapViewSwitch({ variant = 'classic' }) {
  const { available, view, setView, saving, message, saveError } = useMapView();
  if (!available) return null;

  return (
    <div className={`pfp-map-view-switch pfp-map-view-switch--${variant}`} data-map-view={view}>
      <div className="pfp-map-view-switch__segments" role="group" aria-label="Darstellung der Übersicht wählen">
        <button
          type="button"
          aria-pressed={view === MAP_VIEW_CLASSIC}
          aria-label="Klassische Übersicht anzeigen"
          onClick={() => setView(MAP_VIEW_CLASSIC)}
        >
          <span aria-hidden="true">▤</span>
          <span>{view === MAP_VIEW_CLASSIC ? '✓ ' : ''}Klassisch</span>
        </button>
        <button
          type="button"
          aria-pressed={view === MAP_VIEW_3D}
          aria-label="3D-Spielkarte anzeigen"
          onClick={() => setView(MAP_VIEW_3D)}
        >
          <span aria-hidden="true">⬢</span>
          <span>{view === MAP_VIEW_3D ? '✓ ' : ''}3D</span>
        </button>
      </div>
      <span className="pfp-map-view-switch__status" role="status" aria-live="polite">
        {saveError || message || (saving ? 'Ansicht wird gespeichert …' : '')}
      </span>
    </div>
  );
}
